import { SsGhost } from 'src/js/dom/ghost.js';

const lambda = async ( selector, paramF ) => {
  const elms = document.querySelectorAll( selector );
  const defs = typeof paramF !== 'undefined' ? paramF() : {
    prop: { opacity: [ 1, 0 ] },
  };
  for ( let elm of [ ...elms ] ) {
    const ghost = new SsGhost( elm );
    await ghost.velocity( defs );
  }
  return Promise.resolve();
};

export const appear = async () => {
  await Promise.all( [
    lambda( '#ss-thread .thread-head .ghost' ),
    lambda( '#ss-sub-thread .thread-head .ghost' ),
    lambda( '.thread-body .ghost' ),
  ]);
  return lambda( 'footer .ghost' );
};
